<template>
    <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.2846 27.84C10.7089 27.84 11.1159 27.6714 11.4159 27.3714C11.716 27.0713 11.8846 26.6644 11.8846 26.24C11.9456 24.0086 12.8749 21.8891 14.4747 20.3323C16.0746 18.7756 18.2187 17.9046 20.451 17.9046C22.6832 17.9046 24.8274 18.7756 26.4272 20.3323C28.0271 21.8891 28.9564 24.0086 29.0174 26.24V50.6304C29.0174 51.0548 29.1859 51.4617 29.486 51.7618C29.7861 52.0619 30.193 52.2304 30.6174 52.2304C31.0417 52.2304 31.4487 52.0619 31.7487 51.7618C32.0488 51.4617 32.2174 51.0548 32.2174 50.6304V26.24C32.2784 24.0086 33.2077 21.8891 34.8075 20.3323C36.4074 18.7756 38.5515 17.9046 40.7838 17.9046C43.016 17.9046 45.1602 18.7756 46.76 20.3323C48.3599 21.8891 49.2892 24.0086 49.3502 26.24C49.3502 26.6644 49.5187 27.0713 49.8188 27.3714C50.1189 27.6714 50.5258 27.84 50.9502 27.84C51.3745 27.84 51.7815 27.6714 52.0815 27.3714C52.3816 27.0713 52.5502 26.6644 52.5502 26.24C52.5515 23.6524 51.6992 21.1366 50.1252 19.0827C48.5513 17.0288 46.3437 15.5515 43.8447 14.8799C41.3458 14.2083 38.695 14.3799 36.3035 15.3681C33.912 16.3563 31.9134 18.1059 30.6174 20.3456C29.3214 18.1059 27.3227 16.3563 24.9312 15.3681C22.5397 14.3799 19.889 14.2083 17.39 14.8799C14.8911 15.5515 12.6835 17.0288 11.1095 19.0827C9.53559 21.1366 8.68322 23.6524 8.68457 26.24C8.68457 26.6644 8.85314 27.0713 9.1532 27.3714C9.45326 27.6714 9.86023 27.84 10.2846 27.84Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "AriesIcon",
});
</script>
